import { render, staticRenderFns } from "./BaseBottom.vue?vue&type=template&id=b2d50d44&scoped=true&"
import script from "./BaseBottom.vue?vue&type=script&lang=js&"
export * from "./BaseBottom.vue?vue&type=script&lang=js&"
import style0 from "./BaseBottom.vue?vue&type=style&index=0&id=b2d50d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d50d44",
  null
  
)

export default component.exports